import { useData } from "../store/dataStore";

export function useLabeler() {
  const tables = useData((s) => s.tables);
  const reps = new Map((tables.dim_rep || []).map((r) => [r.rep_id, r.name]));
  const accounts = new Map((tables.dim_account || []).map((a) => [a.account_id, a.name]));
  return (field, value) => {
    if (field === "rep_id") return reps.get(value) || value;
    if (field === "account_id") return accounts.get(value) || value;
    return String(value);
  };
}
